var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 1 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("1.")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 2 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("2.")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 3 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("3.")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 4 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("4.")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "badge",
    class: _vm.$route.meta.step === 5 ? 'badge-primary' : 'badge-secondary'
  }, [_vm._v("5.")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header text-center",
    attrs: {
      "data-testid": "registration-step-label"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$route.meta.label) + "\n      ")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('router-view', {
    on: {
      "completed-step": _vm.stepDone,
      "client-id": _vm.setClientId
    }
  })], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0af1803c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Registration/Registration.vue
// module id = 455
// module chunks = 0